import { Route, Routes, Navigate } from "react-router";
import Home from "Pages/Home/Home";
import LoggedinHome from "Pages/Home/LoggedinHome";
import Questionnaire from "components/Questionnaire/Questionnaire";
import OrganizationTree from "components/OrganizationTree/OrganizationTree";
import { routes } from "./routes";
import AuthGuard from "./AuthGuard";
import Faq from "Pages/FAQ/Faq";
import Dashboard from "Pages/Dashboard/Dashboard";
import AccountSettings from "Pages/AccountSettings/AccountSettings";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<AuthGuard isProtected={false} />}>
        <Route path="/faq" element={<Faq />} />
        <Route path="/" element={<Home />} />
      </Route>
      <Route element={<AuthGuard />}>
        <Route path="/home" element={<LoggedinHome />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/organization-tree" element={<OrganizationTree />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/account-settings" element={<AccountSettings />} />
      </Route>
      <Route path="*" element={<Navigate to={routes.home} />} />
    </Routes>
  );
};

export default AppRoutes;
